// Regras puras do feed da comunidade (sem firebase), as mesmas do mobile
// (src/utils/communityRules.ts). O contexto usa estas funções e os testes
// garantem o comportamento.
//
// O feed não lê mais as curtidas e os comentários de cada post: só as
// CONTAGENS (agregação, 1 leitura por post) e se o aluno curtiu. Para a tela
// continuar igual, `dataLikes` e `dataComments` seguem sendo arrays do tamanho
// da contagem, com a curtida do aluno — a única com `userId` — na posição 0.

// Monta os arrays que o CardCommunity lê (`.length` e `.some(userId)`).
export function countPlaceholders(likesCount, commentsCount, myLike = null) {
  const likes = Math.max(0, Number(likesCount) || 0, myLike ? 1 : 0);
  const dataLikes = Array.from({ length: likes }, () => ({}));
  if (myLike) dataLikes[0] = myLike;
  const dataComments = Array.from({ length: Math.max(0, Number(commentsCount) || 0) }, () => ({}));
  return { dataLikes, dataComments };
}

// Junta os docs de um lote à página até `pageSize`, só os que passam no
// filtro do canal. `pageFilledAtDoc` é o doc em que a página encheu: é dali
// que a próxima página continua.
export function appendCommunityPageDocs(currentDocs, incomingDocs, pageSize, shouldIncludeDoc) {
  const docs = [...currentDocs];
  let pageFilledAtDoc = null;

  for (const doc of incomingDocs) {
    if (!shouldIncludeDoc(doc)) continue;

    if (docs.length < pageSize) {
      docs.push(doc);
      if (docs.length === pageSize) {
        pageFilledAtDoc = doc;
        break;
      }
    }
  }

  return { docs, pageFilledAtDoc };
}

const postMillis = (post) => {
  const t = post?.createdAt;
  if (typeof t?.toMillis === 'function') return t.toMillis(); // Timestamp
  if (t instanceof Date) return t.getTime();
  return null;
};

// Posts que saíram da 1ª página porque chegou post novo ACIMA deles — não
// porque foram apagados. Depois de "carregar mais", as páginas extras começam
// depois do cursor antigo; sem devolvê-los a elas, o post empurrado sumia do
// feed. Empurrado = mais antigo que o último da página nova; apagado = some
// do meio dela, mais novo que esse último.
export function postsPushedOutOfFirstPage(prevFirst, nextFirst) {
  if (!nextFirst.length) return [];
  const oldestKept = postMillis(nextFirst[nextFirst.length - 1]);
  if (oldestKept == null) return [];
  const nextIds = new Set(nextFirst.map((p) => p.id));
  return prevFirst.filter((p) => {
    if (nextIds.has(p.id)) return false;
    const t = postMillis(p);
    return t != null && t <= oldestKept;
  });
}

// Curtir/descurtir sem esperar nova leitura: tira a curtida do aluno ou põe
// uma no fim (a contagem anda junto, porque é o tamanho do array).
export function toggleLikeOnPosts(posts, postId, uid, hasLikeBefore) {
  return posts.map((post) => {
    if (post.id !== postId) return post;
    const currentLikes = Array.isArray(post.dataLikes) ? post.dataLikes : [];
    const without = currentLikes.filter((like) => like?.userId !== uid);
    if (!hasLikeBefore) return { ...post, dataLikes: [...without, { userId: uid }] };
    // A curtida existia no servidor mas não estava no array (contagem ainda
    // não carregada): a contagem cai mesmo assim.
    const removed = without.length < currentLikes.length;
    return { ...post, dataLikes: removed ? without : currentLikes.slice(1) };
  });
}
